const SET_SCROLL = 'modules/manageScrollPosition/SET_SCROLL';
const STORE_FOOTER = 'modules/manageScrollPosition/STORE_FOOTER';

const reducer = (state = '', action) => {
  switch (action.type) {
    case SET_SCROLL:
      return action.scrollPosition;
    case STORE_FOOTER:
      return action.footerElement;
    default:
      return state;
  }
};

const setScroll = scrollPosition => {
  return {
    scrollPosition,
    type: SET_SCROLL,
  };
};

const storeFooter = footerElement => {
  return {
    footerElement,
    type: STORE_FOOTER,
  };
};

export { reducer as default, setScroll, storeFooter };
